import React, { useState, useEffect, createContext } from 'react';

type LanguageData = {
  lang: string;
  saveLang: (value: string) => void;
};

export const LanguageContext = createContext({} as LanguageData);

export const LanguageProvider = ({ children }: any) => {
  const path = window.location.pathname.slice(1, 3);
  let initialValue;
  if (path === 'en') {
    initialValue = 'en';
  } else {
    initialValue = 'de';
  }

  const [lang, saveLang] = useState(initialValue);

  useEffect(() => {
    saveLang(lang);
  }, []);

  return <LanguageContext.Provider value={{ lang, saveLang } as LanguageData}>{children}</LanguageContext.Provider>;
};
